import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default function Fallback() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress size={40} />
    </div>
  );
}
